module.exports = __webpack_public_path__ + "img/10.4e34135d.png";